"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _ArticleEditList = _interopRequireDefault(require("./ArticleEditList"));

var _ArticleHeader = _interopRequireDefault(require("./ArticleHeader"));

var _Content = _interopRequireDefault(require("../../preact-components/common/Content"));

var _axios = _interopRequireDefault(require("axios"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ArticleVersions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ArticleVersions, _Component);

  var _super = _createSuper(ArticleVersions);

  function ArticleVersions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ArticleVersions);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "article", void 0);
    var article = props.article;
    _this.state = {
      edits: {
        published: [],
        draft: []
      },
      selectedEdit: undefined,
      latestEdit: undefined,
      publishedAt: null
    };
    _this.article = article;
    _this.showEditContent = _this.showEditContent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ArticleVersions, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res, edits;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _axios.default.get("/article/".concat(this.article.id, "/contentEdits"));

              case 3:
                res = _context.sent;

                if (res.data) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                edits = res.data.edits.reverse();
                this.setState({
                  selectedEdit: edits[0].edited_at,
                  latestEdit: edits[0],
                  publishedAt: res.data.published_at
                });
                this.setGroupedEdits(edits);
                this.trackVersionHistoryViewed();
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                _logger.logger.error(_context.t0, {
                  component: 'ArticleVersions',
                  action: 'componentDidMount'
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setGroupedEdits",
    value: function setGroupedEdits(edits) {
      var _this2 = this;

      var groupedEdits = _objectSpread({}, this.state.edits);

      edits.map(function (edit) {
        var editGroup = !_this2.state.publishedAt || edit.edited_at < _this2.state.publishedAt ? 'draft' : 'published';
        groupedEdits[editGroup] = [].concat((0, _toConsumableArray2.default)(groupedEdits[editGroup]), [edit]);
      });
      this.setState({
        edits: groupedEdits
      });
    }
  }, {
    key: "showEditContent",
    value: function showEditContent(editedAt) {
      this.setState({
        selectedEdit: editedAt
      });
    }
  }, {
    key: "getSelectedEdit",
    value: function getSelectedEdit() {
      var _this$state = this.state,
          edits = _this$state.edits,
          selectedEdit = _this$state.selectedEdit;
      if (!selectedEdit) return;
      return [].concat((0, _toConsumableArray2.default)(edits.published), (0, _toConsumableArray2.default)(edits.draft)).find(function (edit) {
        return edit.edited_at === selectedEdit;
      });
    }
  }, {
    key: "trackVersionHistoryViewed",
    value: function trackVersionHistoryViewed() {
      _publish.default.trackEvent('userevent', {
        'type': 'Article Version History Viewed',
        'article_id': this.article.id,
        'user_id': window.inSidedData.user.userid
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          edits = _this$state2.edits,
          selectedEdit = _this$state2.selectedEdit,
          latestEdit = _this$state2.latestEdit;
      var _this$article = this.article,
          title = _this$article.title,
          url = _this$article.url;
      var selectedEditObject = this.getSelectedEdit();
      return (0, _preact.h)("div", {
        className: "article-versions"
      }, (0, _preact.h)(_ArticleHeader.default, {
        title: title,
        editedAt: latestEdit === null || latestEdit === void 0 ? void 0 : latestEdit.edited_at,
        editedBy: latestEdit === null || latestEdit === void 0 ? void 0 : latestEdit.edited_by,
        url: url
      }), (0, _preact.h)("div", {
        className: "article-versions__content-edit-list-wrapper"
      }, selectedEditObject && (0, _preact.h)(_Content.default, {
        content: selectedEditObject.content,
        className: "article-versions__content",
        isControl: true
      }), (0, _preact.h)(_ArticleEditList.default, {
        edits: edits,
        latestEdit: latestEdit === null || latestEdit === void 0 ? void 0 : latestEdit.edited_at,
        onItemClicked: this.showEditContent,
        selectedEdit: selectedEdit
      })));
    }
  }]);
  return ArticleVersions;
}(_preact.Component);

var _default = ArticleVersions;
exports.default = _default;